import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import GestionTresorerie from "./GestionTresorerie";
import TreasuryMobile from "../mobile/tresorerie/TreasuryMobile";

export default function ResponsiveGestionTresorerie(props) {
  return useIsMobile() ? <TreasuryMobile {...props} /> : <GestionTresorerie {...props} />;
}
